import React from 'react';
import Badge from './Badge';

// Invoice lifecycle → Badge tone. Labels come from the caller (t(...)).
export const INVOICE_LIFECYCLE_TONES = { draft: 'amber', posted: 'green', void: 'gray' };

// Two-axis status cell for tables: a primary status badge plus an optional
// secondary one (e.g. invoice lifecycle + payment status) shown side by side.
// stacked=false → inline, wraps; stacked=true → vertical, for narrow card view.
export default function DualBadgeCell({ primary, secondary, stacked = false, className = '' }) {
  return (
    <span className={`inline-flex ${stacked ? 'flex-col items-start' : 'flex-wrap items-center'} gap-1 ${className}`}>
      <Badge tone={primary.tone}>{primary.label}</Badge>
      {secondary && <Badge tone={secondary.tone}>{secondary.label}</Badge>}
    </span>
  );
}
